import { config_path } from '../router/config.path';

export function getOnboardingCards(appConfig) {

    let isSupportDonations = appConfig && appConfig.features && appConfig.features.contact && appConfig.features.contact.finance && appConfig.features.contact.finance.donations && appConfig.features.contact.finance.donations.is_supported;
    let isSupportOrder = appConfig && appConfig.features && appConfig.features.contact && appConfig.features.contact.order && appConfig.features.contact.order.is_supported;

    const onBoardingCards =  [
    {
        id: "BUSINESS",
        title: "onboarding_business",
        description: "onboarding_business_desc",
        route : null,
        animationLink :"https://cdn.lordicon.com/okgbpdra.json",
        showInOnboarding: true,
        showInLearn : false
    },
    {
        id: "PAYMENT_METHOD",
        title: "onboarding_payment_method",
        description: "onboarding_payment_method_desc",
        route : config_path.my_plans,
        animationLink : "https://cdn.lordicon.com/fgxwhgfp.json",
        redirectText : "add_payment_method",
        showInOnboarding: true,
        showInLearn : true
    },
    {
        id: "OFFERS",
        title: "onboarding_offers",
        description: "onboarding_offers_desc",
        route: config_path.offers_and_promotions,
        animationLink : "https://cdn.lordicon.com/eaegfqtv.json",
        redirectText : "onboarding_offers_redirect",     
        showInOnboarding: true,
        showInLearn : true
    },
    {
        id: "WALLET_BALANCE",
        title: "onboarding_wallet_balance",
        description: "onboarding_wallet_balance_desc",
        route: config_path.my_wallet,
        animationLink : "https://cdn.lordicon.com/lbcxnxti.json",
        redirectText : "onboarding_wallet_balance_redirect",
        showInOnboarding: true,
        showInLearn : true
    },
    {
        id: "ONE_TAP",
        title: "onboarding_onetap",
        description: "onboarding_onetap_desc",
        route: null,
        animationLink : "https://cdn.lordicon.com/ggnoyhfp.json",
        redirectText : "onboarding_onetap_redirect",
        showInOnboarding: true,
        showInLearn : true
    },
    // {
    //     id: "IDENTIFY",
    //     title: "onboarding_identify",
    //     description: "onboarding_identify_desc",
    //     route : null,
    //     animationLink :"https://cdn.lordicon.com/urswgamh.json",
    //     redirectText : "checkIn",

    // },
    // {
    //     id: "SPEND",
    //     title: "onboarding_spend",
    //     description: "onboarding_spend_desc",
    //     route : null,
    //     animationLink :"https://cdn.lordicon.com/ggnoyhfp.json",
    //     redirectText : "spend",
    // },
    {
        id: "ORDER",
        title: "onboarding_order",
        description: "onboarding_order_desc",
        route: config_path.orders_catalogues,
        animationLink : "https://cdn.lordicon.com/jprtoagx.json",
        redirectText : "onboarding_order_redirect",
        showInOnboarding: isSupportOrder,
        showInLearn : isSupportOrder
    },
    {
        id: "DONATIONS",
        title: "onboarding_donations",
        description: "onboarding_donations_desc",
        route: config_path.donations,
        animationLink : "https://cdn.lordicon.com/nvsfzbop.json",
        redirectText : "onboarding_donations_redirect",
        showInOnboarding: isSupportDonations,
        showInLearn : isSupportDonations
    },
    {
        id: "COMMUNITIES",
        title: "onboarding_communities",
        description: "onboarding_communities_desc",
        route: config_path.communities,
        animationLink : "https://cdn.lordicon.com/pfvaixkr.json",
        redirectText : "onboarding_communities_redirect",
        showInOnboarding: false,
        showInLearn : true
    }
    
];
    return onBoardingCards;
}